export enum OnlineOrderingConfigurationTypeEnum {
  storeName = 'Store Name',
  storeAddress = 'Store Address',
  onlineEnabled = 'Online Enabled',
  hiddenEnabled = 'Hidden Enabled',
  storePhone = 'Store Phone',
  storeDescription = 'Store Description',
  tagline = 'Tagline',
  contactEmail = 'Contact Email',
  photoURL = 'Photo URL',
  collectionEnabled = 'Collection Enabled',
  collectionInstructions = 'Collection Instructions',
  deliveryEnabled = 'Delivery Enabled',
  deliveryMinOrder = 'Delivery Min Order',
  deliveryFee = 'Delivery Fee',
  deliveryInstructions = 'Delivery Instructions',
  kerbSideEnabled = 'Kerb Side Enabled',
  collectionKerbSideInstructions = 'Kerb Side Instructions',
  orderAtTableEnabled = 'Order at Table Enabled',
  deliveryArea = 'Delivery Area',
  allowPreorder = 'Allow Preorder',
  preorderPrintBeforeMinutes = 'Preorder Print Before Minutes',
  hiddenOnWhiteLabelEnabled = 'Hidden On White Label Enabled'
 }
